interface MailProps {
  to: string;
  locals: object;
  template: string;
}

export class Mail {
  private props: MailProps;

  constructor(props: MailProps) {
    this.props = props;
  }

  // GETTERs and SETTERs
  get to(): string {
    return this.props.to;
  }

  get locals(): object {
    return this.props.locals;
  }
}
